import Footer from "@/components/FooterNew/Footer"
import Header from "@/components/HeaderNew/Header"
import { Outlet } from "react-router-dom"

export default function GeneralLayout() {
    return (
        <>
            <Header />
            <main className="relative min-h-[calc(100dvh_-_var(--nav-height)_-_var(--footer-height))] ">
                <Outlet />
            </main>
            <Footer />
        </>
    )
}
